import { apiClient } from './client';
import type { OffboardingStatusList, OffboardingStatusTrail } from '@/types/oscar';

/**
 * GET /api/offboarding/status — read-only leaver pipeline status (PR-32).
 * Returns `{ Items, MiUnavailable }`; `MiUnavailable` is true when the on-prem
 * AD/OnsiteLive phase source couldn't be read (email-divert status still current).
 */
export function listOffboardingStatus(signal?: AbortSignal): Promise<OffboardingStatusList> {
  return apiClient.get<OffboardingStatusList>('/api/offboarding/status', signal);
}

/**
 * POST /api/offboarding/group-removals/{userId}/acknowledge — confirm the leaver
 * was removed by hand from the role-assignable groups the runbook skipped
 * (admin/helpdesk; 409 when there is nothing open to acknowledge).
 */
export function acknowledgeRoleAssignableRemoval(userId: number): Promise<unknown> {
  return apiClient.post(`/api/offboarding/group-removals/${userId}/acknowledge`);
}

/** GET /api/offboarding/status/{userId} — full per-user event trail (on-prem + Oscar). */
export function getOffboardingStatusTrail(userId: number, signal?: AbortSignal): Promise<OffboardingStatusTrail> {
  return apiClient.get<OffboardingStatusTrail>(`/api/offboarding/status/${userId}`, signal);
}
